// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RecentSearch_wrapper__1qVhD","recent-search-title":"RecentSearch_recent-search-title__32-vy","item-container":"RecentSearch_item-container__3Vmyj"};